<template>
  <section class="secondary" style="z-index: 100000">
    <v-tabs v-model="active" color="grey " dark slider-color="primary">
      <v-tab :key="0" ripple>SQL designer</v-tab>
      <v-tab :key="1" ripple>SQL tekst</v-tab>
      <v-tab-item :key="0">
        <layer-query-builder :rules="rules" v-model="query">
          <div slot="custom-error" class="red--text">errors</div>
        </layer-query-builder>
      </v-tab-item>

      <v-tab-item :key="1">
        <v-flex grow>
          <v-textarea
            box
            full-width
            hide-details
            rows="5"
            placeholder="SQL spørring"
            v-model="manualSqlString"
          ></v-textarea>
          <span style="display:none">{{ sql }}</span>
        </v-flex>
      </v-tab-item>
    </v-tabs>
  </section>
</template>

<script>
import LayerQueryBuilder from "@/pages/MapPage/Tools/Layers/LayerQueryBuilder.vue";

export default {
  mounted() {
    let exisitingWhereQuery = this.layer.definitionExpression;

    if (exisitingWhereQuery) {
      this.query = this.$store.getters["getLayerDefinitionExpressionQuery"](
        this.layer.url
      );
      this.manualSqlString = exisitingWhereQuery;
    } else {
      this.query = {
        logicalOperator: "all",
        children: []
      };
    }
  },
  data: function() {
    return {
      manualSqlString: "",
      active: 0,
      englishOperators: {
        "er lik (numerisk)": {
          prefix: "",
          operator: " = ",
          postfix: "",
          ignoreValue: false
        },
        "er ikke lik (numerisk)": {
          prefix: "",
          operator: " <> ",
          postfix: "",
          ignoreValue: false
        },
        "er lik": {
          prefix: "",
          operator: " = '",
          postfix: "'",
          ignoreValue: false
        },
        "er ikke lik": {
          prefix: "",
          operator: " <> '",
          postfix: "'",
          ignoreValue: false
        },
        "finnes i": {
          prefix: "",
          operator: "IN('",
          postfix: "')",
          ignoreValue: false
        },
        "finnes ikke i": {
          prefix: "",
          operator: "NOT IN ('",
          postfix: "')",
          ignoreValue: false
        },
        "begynner med": {
          prefix: "",
          operator: "LIKE('",
          postfix: "%')",
          ignoreValue: false
        },
        "begynner ikke med": {
          prefix: "",
          operator: "NOT LIKE('",
          postfix: "%')",
          ignoreValue: false
        },
        inneholder: {
          prefix: "",
          operator: "LIKE('%",
          postfix: "%')",
          ignoreValue: false
        },
        "inneholder ikke": {
          prefix: "",
          operator: "NOT LIKE(%'",
          postfix: "%')",
          ignoreValue: false
        },
        "slutter med": {
          prefix: "",
          operator: "LIKE('%",
          postfix: "')",
          ignoreValue: false
        },
        "slutter ikke med": {
          prefix: "",
          operator: "NOT LIKE('",
          postfix: "%')",
          ignoreValue: false
        },
        "er tom": {
          prefix: "",
          operator: " = ",
          postfix: "''",
          ignoreValue: true
        },
        "er ikke tom": {
          prefix: "",
          operator: " != ",
          postfix: "''",
          ignoreValue: true
        },
        "er null": {
          prefix: "",
          operator: "IS NULL",
          postfix: "",
          ignoreValue: true
        },
        "er ikke null": {
          prefix: "",
          operator: "IS NOT NULL",
          postfix: "",
          ignoreValue: true
        },
        "er mindre enn": {
          prefix: "",
          operator: "<",
          postfix: "",
          ignoreValue: false
        },
        "er mindre enn eller lik": {
          prefix: "",
          operator: " <= ",
          postfix: "",
          ignoreValue: false
        },
        "er større enn": {
          prefix: "",
          operator: " > ",
          postfix: "",
          ignoreValue: false
        },
        "er større enn eller lik": {
          prefix: "",
          operator: " >= ",
          postfix: "",
          ignoreValue: false
        }
      },
      query: null
    };
  },
  props: {
    rules: Array,
    layer: Object
  },
  watch: {
    manualSqlString() {
      this.$emit("query-updated", {
        sql: this.manualSqlString,
        query: this.query
      });
    },
    sql(val) {
      this.manualSqlString = val;
    }
  },
  computed: {
    sql: function() {
      let sqlString = "";
      if (this.query && this.query.hasOwnProperty("children")) {
        this.query.children.forEach(child => {
          let theLogicalOperator =
            sqlString === ""
              ? ""
              : this.query.logicalOperator === "any"
              ? " OR "
              : " AND ";

          sqlString =
            sqlString +
            theLogicalOperator +
            this.getSql(child, child.query.logicalOperator);
        });
      }

      return sqlString;
    }
  },
  methods: {
    getJSONQueryFromArray(sqlArray) {
      let query = {};
      query.children = [];
      for (let i = 0; i < sqlArray.length; i++) {
        let element = sqlArray[i];
        if (Array.isArray(element)) {
          query.children.push(this.getJSONQueryFromArray(element));
        }
      }
    },
    getJSONQuery(parsedSql) {
      let query = {};

      if (parsedSql.hasOwnProperty("AND")) {
        query.logicalOperator = "all";
        query.type = "layer-query-builder-group";
        query.children = [];
        for (let i = 0; i < parsedSql.AND.length; i++) {
          query.children.push(this.getJSONQuery(parsedSql.AND[i]));
        }
      } else if (parsedSql.hasOwnProperty("OR")) {
        query.logicalOperator = "any";
        query.type = "layer-query-builder-group";
        query.children = [];
        for (let i = 0; i < parsedSql.OR.length; i++) {
          query.children.push(this.getJSONQuery(parsedSql.AND[i]));
        }
      } else {
        let operator = parsedSql[Object.keys(parsedSql)[0]];
        let operand = operator[0];
        let value = operator[1];

        let type = "layer-query-builder-rule";

        return {
          type: type,
          query: {
            rule: operand,
            selectedOperator: "er lik (numerisk)",
            selectedOperand: operand,
            value: value
          }
        };
      }

      return query;
    },
    getSql(child, logicalOperator) {
      let sqlString = "";
      if (
        child.query.hasOwnProperty("children") &&
        child.query.children.length > 0
      ) {
        sqlString = sqlString + " (";
        child.query.children.forEach(subChild => {
          let theLogicalOperator =
            sqlString === " ("
              ? ""
              : logicalOperator === "any"
              ? " OR "
              : " AND ";
          sqlString =
            sqlString +
            theLogicalOperator +
            this.getSql(subChild, subChild.query.logicalOperator);
        });
        sqlString = sqlString + ") ";
      } else if (child.query.hasOwnProperty("selectedOperand")) {
        sqlString =
          child.query.selectedOperand +
          " " +
          this.getFormattedOperatorAndValue(child);
      }
      return sqlString;
    },
    getFormattedOperatorAndValue(child) {
      let englishOperator = this.englishOperators[child.query.selectedOperator];

      return (
        englishOperator.prefix +
        englishOperator.operator +
        (englishOperator.ignoreValue ? "" : this.getFormattedValue(child)) +
        englishOperator.postfix
      );
    },
    getFormattedValue(child) {
      if (
        child.query.selectedOperator == null ||
        child.query.selectedOperator == "is empty" ||
        child.query.selectedOperator == "is not empty"
      ) {
        return "";
      }

      if (typeof child.query.value == "string") {
        return child.query.value;
      } else {
        return child.query.value;
      }
    }
  },
  components: {
    LayerQueryBuilder
  }
};
</script>

<style scoped></style>
